import React, { Component } from "react";

class FormFirstStep extends Component {
    render() {
       return (
            <div className="form">
               <p>Cadastrar em</p>
               <h1>{this.props.departmentName}</h1>
               <form className="verify" onSubmit={this.props.onSubmit}>
                    <input name="email" type="email" placeholder="E-mail" required/>
                    <button type="submit">Avançar</button>
               </form>
            </div>
        )
    }
}

export default FormFirstStep;




// WEBPACK FOOTER //
// ./src/app/home/container/formFirstStep.js